import { RouteObject } from "react-router";

import { ErrorPage } from "@/components/errorPage";
import { handleDynamicImportError } from "@/helpers/errorHelpers";
import { LazyFunctionReturnType, RouteType } from "@/types/routes";

export const formsRoutes: RouteObject[] = [
  {
    path: "forms",
    handle: {
      type: RouteType.Forms,
    },
    children: [
      {
        index: true,
        async lazy(): Promise<LazyFunctionReturnType> {
          try {
            const Forms = (await import("../features/forms")).Forms;
            return {
              element: <Forms />,
            };
          } catch (error) {
            handleDynamicImportError(error);

            return {
              element: <ErrorPage />,
            };
          }
        },
      },
    ],
  },
];
